export default "__VITE_ASSET__1625d3b3__"